import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#implement-region-mapping-items-table', () => {
  import('./internal/implement-region-mapping-items-table').then(({ default: Component }) => Component());
});
